var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"36874717f6bc66cec430c0dd6fb011b3a701e4b5"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nmh@try-apt-as"]={id:"36874717f6bc66cec430c0dd6fb011b3a701e4b5"};
      